import { EpH } from "./enum/pH"

export class ControlePH {
    Code: string
    /** Control journee Ph 2 - 7 - 1
     * 
     *  Ajustage Ph 4 - 7 - 10 
     **/
    Type: EpH
    ControleNumeroLot: string
    Temperature: number = null
    ValeurCible: number = null
    ValeurLue: number = null
    get Conforme() {
        if (this.ValeurCible === null || this.ValeurLue === null)
            return false
        const diff = this.Type === EpH.pH4 || this.Type === EpH.pH7005 || this.Type === EpH.pH10 ? 0.05 : 0.10
        const lowerBound = this.ValeurCible - diff;
        const upperBound = this.ValeurCible + diff;
        return this.ValeurLue >= lowerBound && this.ValeurLue <= upperBound;
    }

    toJSON() {
        let ms: any = Object.assign({}, this)
        ms.Conforme = this.Conforme;
        return ms;
    }
    
    static mapFromJSON(json: any): ControlePH {
        const ms = new ControlePH();

        ms.Code = json.code;
        ms.Type = json.type;
        ms.ControleNumeroLot = json.controleNumeroLot;
        ms.Temperature = json.temperature;
        ms.ValeurCible = json.valeurCible;
        ms.ValeurLue = json.valeurLue;
        // ms.Conforme = json.conforme;

        return ms;
    }
}